import { useState } from 'react'
import { bookmakerApi, bmErrorMessage } from '@/api/bookmaker'
import { BmForm, BmPage } from './BmPage'

export function ChangePasswordPage() {
  const [values, setValues] = useState({ oldPassword: '', newPassword: '' })
  const [error, setError] = useState<string | null>(null)
  const [ok, setOk] = useState(false)
  const [busy, setBusy] = useState(false)

  return (
    <BmPage title="Change Password" description="Lab /changePassword" error={error}>
      {ok ? <p>Password updated.</p> : null}
      <BmForm
        fields={[
          { key: 'oldPassword', label: 'Old password', type: 'password' },
          { key: 'newPassword', label: 'New password', type: 'password' },
        ]}
        values={values}
        onChange={(k, v) => setValues((s) => ({ ...s, [k]: v }))}
        busy={busy}
        submitLabel="Change password"
        onSubmit={() => {
          void (async () => {
            setBusy(true)
            setError(null)
            try {
              await bookmakerApi.changePassword(values)
              setOk(true)
            } catch (e) {
              setError(bmErrorMessage(e))
            } finally {
              setBusy(false)
            }
          })()
        }}
      />
    </BmPage>
  )
}
